import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/employee.actions';
import * as home from '../../../../actions/process.home.actions';
import * as inventory from '../../../../actions/process.inventory.actions';

import Fab from '@material-ui/core/Fab';
import Hidden from '@material-ui/core/Hidden';

import Error from '../../../dialogs/Error';
import Menu from '../Menu';
import FilterMenu from './FilterMenu';
import List from './List';
import { AddIcon, FilterIcon } from '../../../../images/icons/WrapSvg';

function toolbar(handleFilter, secondary = false) {
    const color = secondary ? 'secondary' : 'primary';
    return <FilterIcon key={'filter-menu-toolbar'} color={color} onClick={handleFilter} />;
}

class Employees extends React.Component {

    state = {
        hide: false,
        open: undefined,
        local: undefined,
        filter: '',
        desactivados: false
    };

    constructor(props) {
        super(props);
        props.loadEmployees(undefined, undefined);
    }

    componentDidMount() {
        const tools = [toolbar(this.handleFilter)];
        this.props.setTools(tools);
        this.props.setInventoryWindow("employees");
    }

    componentWillUnmount() {
        this.props.setSearch(false);
    }

    handleFilter = (event) => {
        this.setState({ open: event.currentTarget });
    };

    handleCloseMenu = (local, filter, desactivados) => {
        console.log(local, filter, desactivados);
        this.props.loadEmployees(local, filter, false, desactivados);
        const tools = [toolbar(this.handleFilter, !!local || !!filter || !!desactivados)];
        this.props.setTools(tools);
        this.setState({ open: undefined, local: local, filter: filter, desactivados: desactivados });
    };

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    };

    handleClick = (event) => {
        this.props.history.push('/manage/new_employee');
    };

    handleBack = () => {
        /*
            let path = this.props.history.location.pathname.split('/');
            path.splice(path.length - 1, 1);
            path = path.join('/');
            this.props.history.push(path);
            */
           if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    };

    render() {
        const { info } = this.props;
        if (
            info &&
            info.security &&
            info.security.totalPermits &&
            !(info.security.totalPermits.some((f) => f === '84' || f === '20') &&
              info.security.licencias.some((f) => f.id === 150 && f.activo))
        ) {
            return <Error open id={'unauthorized_access'} handleClose={this.handleBack} />;
        } else {
            const { open, local, filter, desactivados } = this.state;
            return (
                <div className={'flex_full_row bg_ice_blue'}>
                    <Hidden xsDown>
                        <div
                            className={
                                'flex_20 overflow_y_scroll padding_top_12 shadow_right_on_tablet bg_white showbar'
                            }
                            onScroll={this.handleScroll}
                        >
                            <Menu code={2} />
                        </div>
                    </Hidden>
                    <div className={'flex_full'}>
                        <div className={'flex_full overflow_y_scroll center height100 bg_ice_blue showbar'}>
                            <List {...this.props} local={local} />
                            <Fab
                                color="primary"
                                aria-label="add"
                                className={'button_float'}
                                onClick={this.handleClick}
                            >
                                <AddIcon />
                            </Fab>
                        </div>
                    </div>
                    {open && (
                        <FilterMenu
                            {...this.props}
                            anchorEl={open}
                            local={local}
                            filter={filter}
                            desactivados={desactivados}
                            handleClose={this.handleCloseMenu.bind(this)}
                        />
                    )}
                </div>
            );
        }
    }
}

const mapStateToProps = (state) => {
    return {
        employees_is_loading: state.employees_is_loading,
        employees_has_errored: state.employees_has_errored,
        employees: state.employees,
        info: state.info,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions, home, inventory), dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(Employees));



// WEBPACK FOOTER //
// ./src/components/complex/manage/employees/Index.js